<template>

    <div v-for="radio in list" class="radio-group">
        <input type="radio" :id="radio.key" :value="radio.value" :name="props.field.key" v-model="value"/>
        <label :for="radio.key" class="radio-label">{{ radio.label }}</label>
    </div>



</template>

<script>


export default {
    name : "InputRadios",

}
</script>

<script setup>

import { ref, watch, computed } from "vue";
import { useStore }             from "vuex";
import { getValue, getList }    from "../composables/useData";

let props = defineProps( [ "field", "data", "datastore" ] );
let emits = defineEmits( [ "update" ] );
let store = useStore();

let value = ref( /*useData.*/getValue( props.field, store.state, "user.profile" ) );

let list = computed( () => /*useData.*/getList( props.field, props.data, props.datastore ) );

watch( value, () => emits( "update", { key : props.field.key, value : value.value } ) )

function hasField (fields)
{
    let strKey = props.field.key;

    return fields.includes(strKey);
}

function getKey ()
{
    return props.field.key;
}

defineExpose({ hasField, getKey });


</script>
<style scoped>

</style>
